export default __webpack_public_path__ + "static/media/icon_confianza.d9186ad4.png";